import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { REVIEWS } from '@Web/Src/constants.js';
import 'swiper/css/pagination';
import 'swiper/css';
import { assetUrl } from '@Shared/Helpers/Utilities';

const Reviews = ({ className = '' }) => {
    return (
        <div
            className={`${className} bg-review bg-defaults xs medium:px-2 relative mt-24 flex w-full flex-col items-center pb-20`}
        >
            <div className={'medium:max-w-20'}>
                <img
                    src={assetUrl('/assets/images/svg/web/reviews/review-quotes.svg')}
                    alt={'quotes'}
                />
            </div>
            <h3 className={'text-dark mt-8 text-3xl font-bold'}>
                {__('Trusted by our customers')}
            </h3>

            <Swiper
                modules={[Pagination, Navigation]}
                loop={true}
                slidesPerView={1}
                spaceBetween={30}
                className={'reviews-swiper relative w-full max-w-[80%]'}
                allowTouchMove={true}
                pagination={{
                    el: '.reviews-swiper-pagination',
                    clickable: true,
                }}
                navigation={{
                    nextEl: '.reviews-swiper .swiper-button-next',
                    prevEl: '.reviews-swiper .swiper-button-prev',
                }}
            >
                {REVIEWS.map((item, index) => (
                    <SwiperSlide
                        className={
                            'mt-16 !flex !w-full flex-col !items-center !justify-center text-center'
                        }
                        key={`swiper_${index}`}
                    >
                        <div className={'flex w-full flex-col items-center'}>
                            <h4 className={'text-dark max-w-3xl text-2xl'}>{item.text}</h4>
                            <div className={'mt-9 size-[72px] overflow-hidden rounded-[50%]'}>
                                <img src={item.img} alt={item.alt} className={'w-full'} />
                            </div>
                            <p className={'text-dark mt-4 text-2xl font-bold'}>{item.name}</p>
                            <p className={'text-dark mt-2 text-lg'}>{item.info}</p>
                            <p className={'text-dark mt-0 text-lg'}>{item.company}</p>
                        </div>
                    </SwiperSlide>
                ))}
                <div className='swiper-button-prev text-dark x_large:hidden absolute left-[5%] top-1/2 z-10 flex size-11 -translate-y-1/2 cursor-pointer items-center justify-center rounded-[50%] bg-white hover:opacity-80'>
                    <img
                        className={'size-8'}
                        src={assetUrl('/assets/images/svg/web/reviews/arrow-left.svg')}
                        alt={'arrow-left'}
                    />
                </div>

                <div className='swiper-button-next text-dark x_large:hidden absolute right-[5%] top-1/2 z-10 flex size-11 -translate-y-1/2 cursor-pointer items-center justify-center rounded-[50%] bg-white hover:opacity-80'>
                    <img
                        className={'size-8'}
                        src={assetUrl('/assets/images/svg/web/reviews/arrow-right.svg')}
                        alt={'arrow-right'}
                    />
                </div>
            </Swiper>
            <div className='reviews-swiper-pagination x_large:block absolute hidden text-center'></div>
        </div>
    );
};

export default Reviews;
